
import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import BulletTextControlView  from 'advanced-visuals/BulletTextControlView.js';


//=====================================================================
//
// An instance of this view represents a Bullet Text control.
//
// Alfonso Cabral, February, 2 2016
//
//=====================================================================
class ControlBulletTextFactory extends BaseVisualControlFactory {

	constructor () {
		super();
	}

	createView( factoryKey, pos ) {

  		const attributes = this.createChildAttributes( factoryKey, pos ) ;

  		//adding silent(accessibility) to attributes.
  		attributes.silent = false;
		attributes.styleColorText = '~textColor';
		attributes.fontFamily = '~textFont';
		attributes.fontSize = '~textFont';
		attributes.textWeight = '~textFont';
		attributes.textStyle = '~textFont';
		attributes.text = `Text 1${String.fromCharCode(13)}Text 2${String.fromCharCode(13)}Text 3`;
		attributes.inlineEditable = true;
        attributes.resizePadding = 2;
        attributes.isHtml = false;
		attributes.minWidth = 10;
		attributes.lowestHeight = 10;
        this.resolveForInitialMinHeight(attributes);
		attributes.translateProps = [
            {key:"text", label:"Text"},
            {key:"toolTip", label:"Tooltip"}
        ];

		const view = new BulletTextControlView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            							pos: pos, factoryKey: factoryKey, id: attributes.id } );

		return view;
	}

}

const controlBulletTextFactory = new ControlBulletTextFactory();

export default controlBulletTextFactory;
